export const moduleName = 'AffiliatedMarketing';
